import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

export interface IOverlaySpinnerProps {
  size?: number;
}
const OverlaySpinner = (props: IOverlaySpinnerProps) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    style={{
      position: 'fixed',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      textAlign: 'center',
      background: 'rgba(0, 0, 0, 0.05)',
      zIndex: 9999
    }}
  >
    <Grid item>
      <CircularProgress size={props.size} />
    </Grid>
  </Grid>
);
export default OverlaySpinner;
